export const DASHBOARD_AUTH_TOKEN_RECEIVED = 'dashboards/DASHBOARD_AUTH_TOKEN_RECEIVED';
export const WIDGETS_UPDATED = 'dashboards/WIDGETS_UPDATED';
export const WIDGET_REMOVED = 'dashboards/WIDGET_REMOVED';
export const WIDGET_ADDED = 'dashboards/WIDGET_ADDED';
export const SET_DASHBOARD_DATETIME = 'dashboards/SET_DASHBOARD_DATETIME'; // set to specific time
export const UNLOCK_DASHBOARD_DATETIME = 'dashboards/UNLOCK_DASHBOARD_DATETIME'; // unlock and track NOW
export const SET_DASHBOARD_MODE = 'dashboards/SET_DASHBOARD_MODE'; //
export const ACTIVATE_INCIDENT_MODE = 'dashboards/ACTIVATE_INCIDENT_MODE';
export const ACTIVATE_NORMAL_MODE = 'dashboards/ACTIVATE_NORMAL_MODE';
export const UPDATE_DISPLAYED_INCIDENT_ID = 'dashboard/UPDATE_ACTIVE_INCIDENT_ID';
export const DASHBOARD_ATTRIBUTES_UPDATED = 'dashboard/DASHBOARD_ATTRIBUTES_UPDATED';
export const SET_CURRENT_DASHBOARD = 'dashboard/SET_CURRENT_DASHBOARD';
export const WIDGET_UPDATED = 'dashboards/WIDGET_UPDATED';
export const WIDGET_SETTINGS_UPDATED = 'dashboards/WIDGET_SETTINGS_UPDATED';
export const UPDATE_EDIT_MODE = 'dashboards/UPDATE_EDIT_MODE';
export const LOCK_INCIDENT = 'dashboards/LOCK_INCIDENT';
